import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {Response} from "../../types/response/Response";
import {geocoderApiQuery} from "../utils/Extensions";
import {DetailedGeocodeResponseDTO, GeocodeRequestDTO} from "../../types/geocoder/GeocodeDTO";
import {GeoSuggestionRequestDTO, GeoSuggestionResponseDTO} from "../../types/geocoder/GeoSuggestionDTO";


export const geocoderApi = createApi({
    reducerPath: "_geocoder",
    baseQuery: geocoderApiQuery,
    tagTypes: ["geocode", "addressHint", "detailedGeocode", "geoSuggestion"],
    endpoints: builder => ({
        getGeocode: builder.query<Response<DetailedGeocodeResponseDTO>, Partial<GeocodeRequestDTO>>({
            query: (data) => ({
                url: "/geocode/detailed",
                method: "POST",
                body: data
            }),
            providesTags: ["geocode"]
        }),
        getDetailedGeocodeBySuggestionId: builder.query<Response<DetailedGeocodeResponseDTO>, Partial<GeoSuggestionRequestDTO>>({
            query: (request) => "/v1/geocode/detailed?source=" + request.source + "&suggestionId=" + request.suggestionId,
            providesTags: ["geocode"]
        }),
        searchGeoSuggestionList: builder.query<GeoSuggestionResponseDTO[], Partial<string>>({
            query: (text) => "/v1/suggestions?text=" + text,
            providesTags: ["geoSuggestion"]
        }),
    })
})

export const {
    useLazyGetGeocodeQuery,
    useLazyGetDetailedGeocodeBySuggestionIdQuery,
    useLazySearchGeoSuggestionListQuery,
} = geocoderApi